import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHomeFilledStyle0 = cosmosIconCss;

const CosmosIconHomeFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHomeFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '820b90d90efbbc4bda2f043dbab7c388d98de3e9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c614086b8a3d8da15e6bcefb275473e742a2f9b7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '039f4925ee1587fa8ebe43ded380b7fffa7f3cd6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.329 9.767a1 1 0 0 0-.329.741v6.986a.508.508 0 0 0 .506.506H8.5a.5.5 0 0 0 .5-.5l.006-5a.5.5 0 0 1 .5-.5h2.988a.505.505 0 0 1 .506.506V17.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-6.992a1 1 0 0 0-.329-.741l-7.338-6.638a.5.5 0 0 0-.666 0L3.329 9.767Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHomeFilledStyle0; }
}, [1, "cosmos-icon-home-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-home-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-home-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHomeFilled$1);
            }
            break;
    } });
}

const CosmosIconHomeFilled = CosmosIconHomeFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHomeFilled, defineCustomElement };
